import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import { squadService } from '../../../services/socialService';
import { notificationService } from '../../../services/notificationService';
import { supabase } from '../../../lib/supabase';

const SquadNotificationActions = ({ notification, onActionComplete }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [actionTaken, setActionTaken] = useState(false);

  const squadId = notification?.metadata?.squad_id;
  const invitationId = notification?.metadata?.invitation_id;

  const handleAccept = async (e) => {
    e?.stopPropagation();
    if (!squadId || !invitationId) return;

    setLoading(true);
    try {
      // Add user to squad
      await squadService?.addSquadMember(squadId, notification?.user_id, 'member');
      
      // Update invitation status
      await supabase
        ?.from('squad_invitations')
        ?.update({ status: 'accepted' })
        ?.eq('id', invitationId);
      
      // Mark notification as read
      await notificationService?.markAsRead(notification?.id);
      
      setActionTaken(true);
      onActionComplete?.();
      
      // Navigate to social hub to view the squad
      setTimeout(() => {
        navigate('/social-hub');
      }, 500);
    } catch (error) {
      console.error('Error accepting squad invitation:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDecline = async (e) => {
    e?.stopPropagation();
    if (!invitationId) return;

    setLoading(true);
    try {
      // Update invitation status
      await supabase
        ?.from('squad_invitations')
        ?.update({ status: 'declined' })
        ?.eq('id', invitationId);
      
      // Mark notification as read
      await notificationService?.markAsRead(notification?.id);
      
      setActionTaken(true);
      onActionComplete?.();
    } catch (error) {
      console.error('Error declining squad invitation:', error);
    } finally {
      setLoading(false);
    }
  };

  if (actionTaken) {
    return (
      <div className="text-sm text-success font-medium">
        ✓ Acción completada
      </div>
    );
  }

  return (
    <div className="flex items-center space-x-2">
      <Button
        variant="solid"
        size="xs"
        onClick={handleAccept}
        disabled={loading}
        iconName="Check"
        className="bg-success hover:bg-success/90 text-white"
      >
        {loading ? 'Aceptando...' : 'Aceptar'}
      </Button>
      <Button
        variant="outline"
        size="xs"
        onClick={handleDecline}
        disabled={loading}
        iconName="X"
        className="border-error text-error hover:bg-error/10"
      >
        {loading ? 'Rechazando...' : 'Rechazar'}
      </Button>
    </div>
  );
};

export default SquadNotificationActions;